<template>
  <container>
    <div slot="bottom_box_content">
      <component :is="curBottomComponent" :contractId="detailId" @on-detail="showDetail"></component>
    </div>
  </container>
</template>

<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'

export default {
  mixins: [sysMixins],
  components: {
    Container,
    listComponent: () => import('./components/Bottom'),
    detailComponent: () => import('./components/Detail.vue')
  },
  data () {
    return {
      pageType: 'list',
      detailId: 0
    }
  },
  mounted () {
    this.initTagEvent()
    this.initComponents()
  },
  destroyed () {
    this.setLinkTagArray()
    this.setLinkRouterMaps()
    this.setActivedTagName('')
  },
  methods: {
    initTagEvent () {
    // 注册头部事件
      this.setLinkRouterMaps(['displaceList', () => {
        this.detailId = 0
        this.pageType = 'list'
        this.initComponents()
      }])
    },
    initComponents () {
      // 清空便签项
      this.setShowLeftBlock(false)
      this.setShowRightBlock(false)
      this.setShowMap(false)
      this.setBottomHeight('90%')
      this.setLeftComponent('')
      this.setRightComponent('')
      this.setLinkTagArray({ key: 'displaceList', value: '合同清单' })

      switch (this.pageType) {
        case 'list':
          this.detailId = 0
          this.setBottomComponent('listComponent')
          this.setActivedTagName('displaceList')
          break
        case 'detail':
          this.setBottomComponent('detailComponent')
          this.setLinkTagArray({ key: 'displaceDetail', value: '合同详情' })
          this.setActivedTagName('displaceDetail')
          break
        default:
          break
      }
    },
    showDetail (id) {
      this.detailId = id
      this.pageType = 'detail'
      this.initComponents()
    }
  }
}
</script>
